import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a circle icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/circle-check?f=classic&s=solid
 */
export const CircleCheckIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCircleCheck} {...props} />;
};
